import {
  classes,
  selectors,
  SPACE_FROM_TOP } from '@/behaviour/header_navigation/variables'
import { isGispOrigin } from '@/libs/env/index'
import { $ } from '@/libs/jquery/index'
import { ScrollChecking } from '@/libs/scroll_check/index'

export class HeaderFixedNavigation {

  private selectors: ISelectors = selectors
  private classes: IClasses = classes

  private base: JQuery | null = null
  private prevScrollTop: number = 0

  public constructor() {
    this.base = $(this.selectors.base)

    if (this.base.length && !isGispOrigin) {
      this.init()
    }
  }

  private init(): void {
    this.checkScrollAndUpdate = this.checkScrollAndUpdate.bind(this)
    this.bindScroll()
    this.bindEvents()
  }

  private bindScroll(): void {
    ScrollChecking.getInstance().addCallBack(this.checkScrollAndUpdate)
  }

  private bindEvents(): void {
    this.base.on('click', this.selectors.menu, () => this.openFilters())
  }

  private checkScrollAndUpdate(currentScrollTop: number): void {
    if (currentScrollTop === this.prevScrollTop) {
      return
    }

    // каждый раз при выплывании панели надо чтобы меню можно было открыть
    // задвигать панель плавно

    if (currentScrollTop > SPACE_FROM_TOP) {
      // показываем фиксированную шапку
      this.base.addClass(this.classes.fixedHeader)
    } else {
      // показываем статичную шапку
      this.base
        .removeClass(this.classes.fixedHeader)
        .find(this.selectors.filtersWrapper).removeAttr('style')
    }
    this.prevScrollTop = currentScrollTop
  }

  private openFilters(): void {
    this.base.find(this.selectors.filtersWrapper).slideToggle()
  }
}
